// NOTE: this file exist only so that there aren't import * in other files

import * as D3 from 'd3';

export default D3;
